import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export const EMAR_TIMELINE_MAXIMUM_HOURS_QTY_VALIDATOR = 'emar-timeline-maximum-hours-qty-validator';
export default async function emarTimelineMaximumHoursQtyValidator(value) {
    let valid = value <= 72;
    let message = valid ? '' : MessageService.translate('tws.emar.maximum-number-hours').replace('#@NR_HORAS#@', '72');
    if (value < 0) {
        message = MessageService.translate('tws.formatter.integer.invalid');
        valid = false;
    }
    return [{
            message: message,
            name: EMAR_TIMELINE_MAXIMUM_HOURS_QTY_VALIDATOR,
            valid: valid
        }];
}
//# sourceMappingURL=emar-timeline-maximum-hours-qty-validator.js.map